export default __webpack_public_path__ + "static/media/ashe-bob.36eeca7e.mp3";